import React, { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLocation } from '@thd-olt-component-react/router';

const ITEM_ID_PRODUCT = /(?:\/[\w-]+)?\/p(?:\/[\w-]+)?\/(\d+)/;
const ITEM_ID_CONFIG  = /\/config\/[a-f0-9-]+\/[^/]+\/(\d+)$/;
const PAINT_CONFIG_ID = /\/config\/([a-f0-9-]+)\//;

const resolveToken = (val, ctx) => {
  switch (val) {
    case '$channel':  return ctx.expContext.channel;
    case '$storeId':  return ctx.store.storeId;
    case '$storeZip': return ctx.store.storeZip;
    case '$pathname': return ctx.pathname;
    case '$itemId': {
      if (ctx.itemId) return ctx.itemId;
      const m = ITEM_ID_PRODUCT.exec(ctx.pathname) || ITEM_ID_CONFIG.exec(ctx.pathname);
      return m ? m[1] : '';
    }
    case '$paintReorderConfigId': {
      if (ctx.paintReorderConfigId) return ctx.paintReorderConfigId;
      const m = PAINT_CONFIG_ID.exec(ctx.pathname);
      return m ? m[1] : '';
    }
    case '$contentId': return ctx.contentId;
    case '$preloadImages': return ctx.preloadImages;
    default: return val;
  }
};

const hydrateValue = (val, ctx) => {
  if (typeof val === 'string') {
    return val.charCodeAt(0) === 36 ? resolveToken(val, ctx) : val;
  }
  if (val !== null && typeof val === 'object') {
    if (Array.isArray(val)) {
      const len = val.length;
      const out = new Array(len);
      for (let i = 0; i < len; i += 1) out[i] = hydrateValue(val[i], ctx);
      return out;
    }
    return hydrateProps(val, ctx);
  }
  return val;
};

export const hydrateProps = (props, ctx) => {
  const out = {};
  const keys = Object.keys(props);
  for (let i = 0; i < keys.length; i += 1) {
    const k = keys[i];
    out[k] = hydrateValue(props[k], ctx);
  }
  return out;
};

export const useHydratedProps = (component, opts = {}) => {
  const expContext = useContext(ExperienceContext);
  const store = useStore();
  const { pathname } = useLocation();

  const ctx = {
    store,
    expContext,
    pathname:
      pathname || (typeof window !== 'undefined' ? window.location.pathname : ''),
    itemId: opts.itemId,
    contentId: opts.contentId,
    preloadImages: opts.preloadImages
  };

  if (Array.isArray(component)) {
    const ret = component.map((comp) => hydrateProps(comp.props, ctx));
    return opts.mergeArray
      ? ret.reduce((acc, cur) => ({ ...acc, ...cur }), {})
      : ret;
  }
  return hydrateProps(component.props, ctx);
};